export function formatNumberDigits(number?: number | string) {
  if (number === undefined) return '';

  return Number(number).toLocaleString('fullwide', {
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  });
}
